type ReactNativeWebViewBridge = { postMessage: (message: string) => void }

function getNativeBridge(): ReactNativeWebViewBridge | null {
  if (typeof window === 'undefined') return null
  const host = window as unknown as {
    ReactNativeWebView?: ReactNativeWebViewBridge
  }
  return host.ReactNativeWebView ?? null
}

/** No-op outside a React Native WebView. */
export function notifyNativeImageEditorState(open: boolean): void {
  const bridge = getNativeBridge()
  if (!bridge) return

  try {
    bridge.postMessage(
      JSON.stringify({ type: 'IMAGE_EDITOR', payload: { data: { open } } })
    )
  } catch {
    // noop
  }
}
